import React, { useState } from 'react'
import { colors, alpha } from '../style'

const AdministrativeFormInfo = ({ lang }) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false)

  const content = {
    administrating: {
      pl: `<p><strong>Dobrowolność i prawo do wycofania zgody:</strong> <br/>Administratorami danych osobowych są podmioty wchodzące w skład OMIDA Group, zwane w dalszej części łącznie „Administratorami. Administratorzy wyznaczyli wspólny punkt kontaktowy, który obsługuje Inspektor ochrony danych OMIDA Group. W sprawach ochrony danych osobowych można się kontaktować z Administratorami:</p><ul><li>korespondencyjnie – kierując zapytania na adres Aleja Grunwaldzka 472C, 80-309 Gdańsk</li><li>drogą korespondencji elektronicznej na adres: iodo@omida.pl</li></ul><p>Wyrażenie zgody jest dobrowolne. W dowolnym momencie możesz wycofać swoją zgodę lub sprzeciwić się przetwarzaniu Twoich danych osobowych w celach dotyczących marketingu bezpośredniego. W zakresie w jakim zgoda została wycofana, nie będziemy mogli kontaktować się z Tobą aby przekazać Ci informacje lub wskazówki dotyczące produktów lub usług Omida Group. Wyrażenie lub niewyrażenie zgody nie ma wpływu na jakiekolwiek inne zgody wyrażone w przeszłości lub takie, które zostaną wyrażone w przyszłości. Każda zgoda pozostaje ważna do czasu wycofania.</p>`,
    },
    administratingSecond: {
      pl: `<p><sup>[1]</sup> Podmioty wchodzące w skład OMIDA Group:</p><ol><li>OMIDA Group S.A.</li><li>Omida VLS Sp. z o.o.</li><li>Omida Sea And Air S.A.</li><li>Omida Solutions Sp. z o.o.</li><li>Omida 7R Solutions Sp. z o.o.</li><li>Omida Iberica SL</li><li>Omida Finance Sp. z o.o.</li><li>Omida Shared Services Center Sp. z o.o.</li></ol>`,
    },
    dictonary: {
      showMore: {
        pl: 'Pokaż więcej',
        en: 'Show more',
      },
      showLess: {
        pl: 'Pokaż mniej',
        en: 'Show less',
      },
    },
  }

  return (
    <div css={sFormTextBottom}>
      <div css={[sAdminText, !isTextExpanded && sAdminTextCollapsed]}>
        <div
          dangerouslySetInnerHTML={{ __html: content.administrating[lang] }}
        />
        <div
          dangerouslySetInnerHTML={{
            __html: content.administratingSecond[lang],
          }}
          css={{ paddingTop: '10px' }}
        />
      </div>
      <button
        onClick={() => setIsTextExpanded(!isTextExpanded)}
        css={sShowMoreButton}>
        {isTextExpanded
          ? content.dictonary.showLess?.[lang] || 'Show less'
          : content.dictonary.showMore?.[lang] || 'Show more'}
      </button>
    </div>
  )
}

// Styles
const sFormTextBottom = {
  fontSize: '0.75rem',
  lineHeight: '1.5',
  color: colors.text.concat(alpha[60]),
}

const sAdminText = {
  transition: 'max-height 0.3s ease-out',
  overflow: 'hidden',
  '& ul, & ol': {
    paddingLeft: '1.25rem',
    marginBottom: '.25rem',
  },
}

const sAdminTextCollapsed = {
  maxHeight: '20px',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '25px',
  },
}

const sShowMoreButton = {
  background: 'none',
  border: 'none',
  color: colors.text,
  cursor: 'pointer',
  fontWeight: 700,
  padding: '0.5rem 0',
  fontSize: '10px',
  '&:hover': {
    textDecoration: 'underline',
  },
}

export default AdministrativeFormInfo
